<template>
  <div>
    <a-spin :spinning="spinning" :delay="50">
      <div class="is-main f-mb15">
        <div class="container">
          <section class="m-location f-mb10">
            <span>当前位置：</span>
            <a href="/home" tppabs="https://ahqjrd.gov.cn/">网站首页</a> >
            <a :href="pagePath">{{ name }} </a>
            <span v-if="nav != 0">
              >
              <a
                :href="
                  pagePath +
                  '?nav=' +
                  nav +
                  '&nav2=' +
                  (menuList[nav - 1].childList.length ? 0 : '')
                "
                >{{ menuList[nav - 1].name }}
              </a>
            </span>
            <span v-if="nav2 !== null && nav2 !== 0">
              >
              <a :href="pagePath + '?nav=' + nav + '&nav2=' + nav2"
                >{{
                  nav2 == 0
                    ? menuList[nav - 1].name
                    : menuList[nav - 1].childList[nav2 - 1].name
                }}
              </a>
            </span>
          </section>
          <div class="m-pgpdbox1">
            <div class="row f-mlrf10">
              <section class="col-md-3 f-plr10 m-listlf f-md-mb15">
                <div class="g-listlf">
                  <h1 class="hidden-sm hidden-xs u-tit">
                    <span></span
                    >{{ nav2 !== null ? menuList[nav - 1].name : name }}
                  </h1>
                  <h2 class="visible-sm visible-xs u-tit">{{ name }}</h2>
                  <ul v-if="nav2 === null">
                    <li
                      v-for="r in menuList"
                      :key="r.query"
                      :class="nav == r.nav ? 'u-active' : ''"
                      @click="changeType(r)"
                    >
                      <a :title="r.name">{{ r.name }}</a>
                    </li>
                  </ul>
                  <ul v-else>
                    <li
                      v-for="r in menuList[nav - 1].childList"
                      :key="r.query"
                      :class="nav2 == r.nav ? 'u-active' : ''"
                      @click="changeType(r)"
                    >
                      <a :title="r.name">{{ r.name }}</a>
                    </li>
                  </ul>
                </div>
              </section>
              <section class="col-md-9 f-plr10 m-listrg">
                <div class="m-titstyle1 f-clearfix f-mb5">
                  <span class="u-tit f-fl" v-if="nav2 === null"
                    >{{ nav == 0 ? name : menuList[nav - 1].name }} <em></em
                  ></span>
                  <span class="u-tit f-fl" v-else
                    >{{
                      nav2 == 0
                        ? menuList[nav - 1].name
                        : menuList[nav - 1].childList[nav2 - 1].name
                    }}
                    <em></em
                  ></span>
                </div>
                <div class="m-cglist m-liststyle1 f-md-mb15">
                  <ul style="min-height: 680px">
                    <li
                      :class="(i + 1) % 5 == 0 ? 'f-line' : ''"
                      v-for="(r, i) in newsList"
                      :key="i"
                      @click="goDetail(r)"
                    >
                      <span>{{ r.publishDate }}</span
                      ><a :title="r.name" target="_blank">{{ r.title }}</a>
                    </li>
                  </ul>
                </div>
                <div class="text-right m-paginationyun7">
                  <div id="pagination" class="f-fr">
                    <a-pagination
                      show-quick-jumper
                      v-model="pageOptions.page"
                      :total="pageOptions.total"
                      :page-size="pageOptions.pagesize"
                      show-less-items
                      @change="onChange"
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
              <script>
import { listMenu, getNewsTypeList } from "@/api/base";
export default {
  name: "navBar",
  data() {
    return {
      id: "9",
      name: "一府一委两院",
      pagePath: "",
      imgBaseUrl: process.env.VUE_APP_API_BASE_URL + "/sys/common/static/",
      spinning: false,
      nav: 0,
      nav2: null,
      menuList: [],
      pageOptions: {
        total: 0,
        pagesize: 15,
        page: 1,
      },
      newsList: [],
    };
  },
  methods: {
    changeType(item) {
      if (this.nav2 !== null) {
        this.nav2 = item.nav;
      } else {
        this.nav = item.nav;
        if (item.childList.length) {
          this.nav2 = 0;
        } else {
          this.nav2 = null;
        }
      }
      this.$router.push({
        name: this.pagePath,
        query: {
          nav: this.nav,
          nav2: this.nav2,
        },
      });
      this.pageOptions.page = 1;
      this.init();
    },
    goDetail(item) {
      const routeurl = this.$router.resolve({
        name: "detail",
        query: {
          id: item.id,
        },
      });
      window.open(routeurl.href, "_blank");
    },
    onChange(e) {
      this.pageOptions.page = e;
      this.init();
    },
    init() {
      this.spinning = true;
      this.newsList = [];
      let type = "";
      if (this.nav == 0 && this.nav2 == null) {
        type = this.id;
      } else if (this.nav2 === null || this.nav2 == 0) {
        type = this.menuList[this.nav - 1].id;
      } else {
        type = this.menuList[this.nav - 1].childList[this.nav2 - 1].id;
      }
      getNewsTypeList({
        pageSize: this.pageOptions.pagesize,
        page: this.pageOptions.page,
        type,
      })
        .then((res) => {
          if (res.code == 200) {
            this.newsList = res.result.records;
            this.pageOptions.total = res.result.total;
          }
        })
        .finally(() => {
          this.spinning = false;
        });
    },
  },
  async created() {
    let pageIndex = 0;
    if (localStorage.getItem("menus")) {
      let result = JSON.parse(localStorage.getItem("menus"));
      result.forEach((r, i) => {
        if (r.id == this.id) {
          this.name = r.name;
          this.menuList = r.childList;
          this.pagePath = r.alias;
          pageIndex = i + 1;
        }
      });
    } else {
      const { result } = await listMenu();
      result.forEach((r, i) => {
        if (r.id == this.id) {
          this.name = r.name;
          this.menuList = r.childList;
          this.pagePath = r.alias;
          pageIndex = i + 1;
        }
      });
    }
    this.menuList.forEach((item, index) => {
      item.nav = index + 1;
      if (item.childList) {
        item.childList.forEach((r, i) => {
          r.nav = i + 1;
        });
      }
    });
    this.$store.commit("SET_NAV", pageIndex + 1);
    if (this.$route.query.nav) {
      this.nav = Number(this.$route.query.nav);
    }
    if (this.$route.query?.nav2 && this.$route.query?.nav2 != "null") {
      this.nav2 = Number(this.$route.query?.nav2);
    }
    this.init();
  },
};
</script>
                <style lang="less" scoped>
.m-titstyle1 {
  background: url("../../assets/imgs/bg-tit1-line.png") left center repeat-x;
}
.m-titstyle1 .u-tit {
  background: url("../../assets/imgs/bg-tit1.png") left center no-repeat;
  background-color: #fff;
}
.m-location {
  background: url("../../assets/imgs/icon-location.png") left 6px no-repeat;
}
.f-clearfix:after {
  display: block;
  height: 0;
  visibility: hidden;
  font-size: 0;
  content: " ";
  clear: both;
}
.m-listlf .u-tit {
  padding: 22px 0;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  background: #c60000;
}
.g-listlf {
  min-height: 765px;
  background: #f5f5f5;
}
.g-listlf ul {
  padding: 10px 20px;
}
ul,
ol,
ul li,
li,
ol li {
  list-style: none;
}
.m-listlf .u-tit span {
  display: inline-block;
  margin: -5px 20px 0 0;
  width: 28px;
  height: 24px;
  vertical-align: middle;
  background: url("../../assets/imgs/icon-tit.png") no-repeat;
}
.g-listlf li a {
  color: #333;
  display: block;
  padding: 20px 20px 20px 10px;
  font-size: 18px;
  border-bottom: 1px solid #e6e6e6;
  background: url("../../assets/imgs/bg-listlf.png") right center no-repeat;
}
.g-listlf li a:hover,
.g-listlf li.u-active a {
  background: url("../../assets/imgs/bg-listlf-h.png") right center no-repeat;
  color: #c60000;
}
.m-liststyle1 li a {
  display: block;
  padding-left: 15px;
  background: url("../../assets/imgs/icon-li1.png") left center no-repeat;
  overflow: hidden;
  word-wrap: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
}
a {
  color: #333;
  border: none;
  text-decoration: none;
  outline: none;
}
a:hover {
  text-decoration: none;
  color: #c60000;
}
.m-cglist li.f-line {
  margin-bottom: 10px;
  padding-bottom: 10px;
  height: 52px;
  border-bottom: 1px dashed #ddd;
}
</style>